module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "book",
    attrs: {
      "title": "Slow Cooker Double Dinners for Two"
    }
  }, [_c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "recto"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "index"
    }
  }, [_vm._v("Slow Cooker Double Dinners for Two")])]), _c('a', {
    attrs: {
      "id": "index"
    }
  }, [_c('h2', [_vm._v("Cook Once, Eat Twice!")]), _vm._v(" "), _c('h3', {
    staticClass: "author"
  }, [_vm._v("Cynthia Graubart")]), _vm._v(" "), _c('h4', [_vm._v("Photographs by Rick McKee ")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Gibbs Smith Logo",
      "src": "images/logo.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "index"
    }
  }, [_c('div', {
    staticClass: "verso"
  }, [_c('p', {
    staticClass: "versotitle"
  }, [_vm._v("Slow Cooker Double Dinners for Two")]), _vm._v(" "), _c('p', {
    staticClass: "versotitle"
  }, [_vm._v("Cook Once, Eat Twice!")]), _vm._v(" "), _c('p', [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Text © 2014 Cynthia Graubart")]), _vm._v(" "), _c('p', [_vm._v("Photographs © 2014 by Rick McKee ")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced by any means\n                        whatsoever without written permission from the publisher, except brief\n                        portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Orders: 1.800.835.4993")]), _vm._v(" "), _c('p', [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4236-3626-7")])])])]), _c('a', {
    attrs: {
      "id": "index"
    }
  }, [_c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "acknowledgements",
    attrs: {
      "title": "Acknowledgements"
    }
  }, [_c('h3', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', [_vm._v("I owe a debt of gratitude to the incomparable Nathalie Dupree for her\n                        friendship, mentorship, and most of all, the idea for this book! I’m still\n                        loving our near thirty-year journey together and treasure your support. ")]), _vm._v(" "), _c('p', [_vm._v("My team is simply fabulous: photographer Rick McKee shot these taste-tempting\n                        photos (with the patience of a saint); talented food stylist Nan McCullough\n                        brought out the very best in my recipes (it’s our second book together);\n                        Elise Garner is my right hand in times of crisis, exemplifying all you could\n                        want in an assistant; and Rebecca Battle, who has the most gentle and\n                        professional manner, was my double in thought, word, and deed when my\n                        energies had to be focused elsewhere during shooting. ")]), _vm._v(" "), _c('p', [_vm._v("My publishing team at Gibbs Smith gives me plenty of reasons why producing a\n                        book with a small publisher is such a pleasure. Deep thanks to my editor\n                        extraordinaire, Madge Baird. Thanks also to all of those who perform duties\n                        behind the scenes that when put together make a wonderful book that I’m\n                        proud to put my name on. ")]), _vm._v(" "), _c('p', [_vm._v("My family has enjoyed this journey with me and provides such love and\n                        support. Thank you to my husband, Cliff, and my children, Norman and\n                        Rachel.")])])])])]), _c('a', {
    attrs: {
      "id": "index"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61faee50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 60
// module chunks = 0